import { Injectable } from '@angular/core';
import each from 'lodash/each';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import has from 'lodash/has';

export type GeneratedDocketComponentType = {
  [type: string]: string[];
};

export interface IGeneratedDocket {
  order_id: string;
  receipt: GeneratedDocketComponentType;
  split_dockets: {
    [group_id: number]: GeneratedDocketComponentType;
  };
  last_updated: number;
}

@Injectable({
  providedIn: 'root',
})
export class GeneratedDocketRepositoryService {
  private _generated_dockets: IGeneratedDocket[] = [];

  constructor() {}

  /**
   * Add one or more orders to be stored in the respository
   * @param dockets The array of generated dockets to be stored
   */
  public addMultipleGeneratedDockets(dockets: IGeneratedDocket[]): void {
    each(dockets, (docket: IGeneratedDocket) => {
      this.addDocketToRepository(docket);
    });
  }

  /**
   * Add a order to the respository
   * @param docket The generated dockets to be stored
   */
  public addGeneratedDocket(docket: IGeneratedDocket): void {
    this.addDocketToRepository(docket);
  }

  /**
   * Gets an order frome the respository by ID
   * @param docket The generated dockets to be stored
   */
  public getGeneratedDocketById(id: string): IGeneratedDocket {
    return find(this._generated_dockets, { order_id: id });
  }

  /**
   * Gets the _generated_dockets list
   * @returns _generated_dockets : the full generated dockets list in the repository
   */
  public getAllGeneratedDockets(): IGeneratedDocket[] {
    return this._generated_dockets;
  }

  /**
   * Function to run a check if the docket already exists (by ID)
   * and Add it if it doesnt exist
   * and Override it if it does exist
   * @param docket The docket to add to the Repo
   * @returns { Boolean } If the update is successful
   */
  addDocketToRepository(docket: IGeneratedDocket): boolean {
    let retVal: boolean = false;

    if (this.isDocketDataValid(docket)) {
      // First check the docket doesn't already exist
      if (!this.getGeneratedDocketById(docket.order_id)) {
        this._generated_dockets.push(docket);
        retVal = true;

        console.log('Insert docket repo', docket.order_id);
      } else {
        if (docket.last_updated > this.getGeneratedDocketById(docket.order_id).last_updated) {
          const index = findIndex(this._generated_dockets, { id: docket.order_id });
          this._generated_dockets.splice(index, 1, docket);
          retVal = true;

          console.log('Update docket repo', docket.order_id);
        }
      }
    } else {
      console.log('Invalid docket format', docket);
    }

    return retVal;
  }

  /**
   * Checks if the generated docket is valid
   * @param docketData The IGeneratedDocket data to validate
   * @returns boolean
   */
  private isDocketDataValid(docketData: IGeneratedDocket) {
    return (
      docketData &&
      has(docketData, 'order_id') &&
      has(docketData, 'receipt') &&
      has(docketData, 'split_dockets') &&
      has(docketData, 'last_updated')
    );
  }

  /**
   * Removes a generated docket from the list
   * @params The generated docket ID
   */
  public removeGeneratedDocketByID(ids: string[]) {
    each(ids, (id: string) => {
      const index = findIndex(this._generated_dockets, { ids });
      if (index > -1) {
        this._generated_dockets.splice(index, 1);
      }
    });
  }

  public reset() {
    this._generated_dockets = [];
  }
}
